const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://server.acpca.net/api';

class ApiService {
  // Get all content
  async getAllContent() {
    try {
      const response = await fetch(`${API_BASE_URL}/content/all`);
      const data = await response.json();
      if (data.success) {
        return data.data;
      }
      throw new Error(data.message || 'Failed to fetch content');
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Get services
  async getServices() {
    try {
      const response = await fetch(`${API_BASE_URL}/services`);
      const data = await response.json();
      if (data.success) {
        return data.data;
      }
      throw new Error(data.message || 'Failed to fetch services');
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Get portfolio projects
  async getPortfolio() {
    try {
      const response = await fetch(`${API_BASE_URL}/portfolio`);
      const data = await response.json();
      if (data.success) {
        return data.data;
      }
      throw new Error(data.message || 'Failed to fetch portfolio');
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Submit contact form
  async submitContactForm(formData) {
    try {
      const response = await fetch(`${API_BASE_URL}/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Newsletter subscription
  async subscribeNewsletter(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/contact/newsletter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }
}

export default new ApiService();

